<div
  class="card w-96 h-36 hover:shadow-lg cursor-pointer flex flex-col"
  [routerLink]="link()"
>
  <div class="h-11 flex border-b px-4 items-center flex-none">
    <h3 class="subheading-2 font-medium text-secondary m-0">
      {{ titulo() }}
    </h3>
  </div>
  <div class="flex flex-row gap-3 px-4 items-center flex-1">
    <div
      class="rounded-full h-14 w-14 flex items-center justify-center text-primary-600 bg-primary-600/10 flex-none"
    >
      <mat-icon class="icon-xl" svgIcon="{{ icone() }}"></mat-icon>
    </div>
    <div class="flex flex-col flex-1">
      <div class="body-2 mb-1">
        {{ texto() }}
      </div>
      <div class="underline text-primary-600 caption">{{ textoLink() }} ></div>
    </div>
  </div>
</div>
